<template>
  <div class="pax--wrap">
    <div class="pax">
      <div
        @mouseover="hover = true"
        @mouseleave="hover = false"
      >
        <passenger-icon />
      </div>
      <div class="px-3">
        <div>
          <span class="pax-name">{{ passenger.alt }}</span>
          <small
            class="pax-main"
            v-if="passenger.main"
          >
            {{ passenger.type_es }} (Titular)
          </small>
          <small
            class="pax-main"
            v-else
          >{{ passenger.type_es }}</small>
        </div>
      </div>
      <div
        class="pax-btns"
        v-if="$store.state.modify.reservation.editable"
      >
        <button
          class="pax-btn"
          :disabled="!editable"
          @click="e => $refs.form.open()"
          v-if="
            passenger.type == PASSENGER_TYPES.infoas.str ||
              (!!passenger.seat_id && !!passenger.rooming)
          "
        >
          Editar
        </button>
        <button
          class="pax-btn"
          :disabled="!editable"
          @click="$emit('sit', passenger.tmp_id)"
          v-if="passenger.type != PASSENGER_TYPES.infoas.str && !passenger.seat_id"
        >
          Asignar asiento
        </button>
        <button
          class="pax-btn"
          :disabled="!editable"
          @click="$emit('locate', passenger.tmp_id)"
          v-if="
            ![PASSENGER_TYPES.infoas.str, PASSENGER_TYPES.infoascb.str].includes(
              passenger.type
            ) &&
              passenger.seat_id &&
              passenger.rooming == null
          "
        >
          Asignar habitaciones
        </button>
      </div>
      <div class="pr-2 ml-auto">
        <div>
          <span class="pax-txt">{{ passenger.seat_categ_str }}</span>
          <span
            class="pax-txt"
            v-if="fee"
          >{{ fee.txt }}</span>
          <span
            class="pax-txt"
            v-if="insurance"
          >{{ insurance }}</span>
          <span
            class="pax-txt"
            v-if="price && passenger.type != PASSENGER_TYPES.infoas.str"
          >
            {{ price }}
          </span>
        </div>
      </div>
      <transition name="list">
        <div
          class="pax--tooltip"
          v-if="
            hover &&
              (passenger.ident ||
                passenger.gender ||
                passenger.nationality ||
                passenger.areacode ||
                passenger.tel ||
                passenger.boarding_id)
          "
        >
          <ul
            style="list-style: none;"
            class="p-0 m-0"
          >
            <li v-if="passenger.ident">
              <span>Dni/Pasaporte: </span><strong>{{ passenger.ident }}</strong>
            </li>
            <li v-if="passenger.gender">
              <span>Sexo: </span><strong>{{ passenger.gender }}</strong>
            </li>
            <li v-if="passenger.nationality">
              <span>Nacionalidad: </span><strong>{{ passenger.nationality }}</strong>
            </li>
            <li v-if="passenger.areacode">
              <span>Codigo de area: </span><strong>{{ passenger.areacode }}</strong>
            </li>
            <li v-if="passenger.tel">
              <span>Tel: </span><strong>{{ passenger.tel }}</strong>
            </li>
            <li v-if="passenger.boarding_id">
              <span>Embarque: </span>
              <strong>
                {{
                  $store.state.modify.departure.boardings.find(
                    b => b.id == passenger.boarding_id
                  ).name
                }}
              </strong>
            </li>
            <li v-if="passenger.notes">
              <span>Notas: </span><strong>{{ passenger.notes }}</strong>
            </li>
          </ul>
        </div>
      </transition>
    </div>
    <passenger-form
      :passenger="passenger"
      ref="form"
      @input="$emit('input', passenger)"
    />
  </div>
</template>

<script>
import PassengerIcon from '@/components/PassengerIcon'
import PassengerForm from './PassengerForm'
import Btn from '@/components/Btn'
import { PASSENGER_TYPES, FEES } from '@/constans'

export default {
  components: { Btn, PassengerIcon, PassengerForm },

  props: ['passenger', 'editable'],

  data () {
    return {
      PASSENGER_TYPES,
      hover: false
    }
  },

  computed: {
    fee () {
      return this.passenger.rooming && FEES[this.passenger.rooming.base]
        ? FEES[this.passenger.rooming.base]
        : null
    },
    price () {
      if (!this.$store.state.modify.budget.passengers) {
        return null
      }

      var { price } =
				(Object.values(this.$store.state.modify.budget.passengers) || []).find(
				  p => p.id == this.passenger.id
				) || {}

      return this.$store.state.modify.budget.currency + parseInt(price)
    },
    insurance () {
      return this.passenger.insurance_old || this.passenger.insurance_outland
        ? 'COBERTURA MEDICA ' +
						this.$store.state.modify.departure.currency +
						(this.passenger.insurance_old + this.passenger.insurance_outland)
        : null
    }
  }
}
</script>
